module.exports = __webpack_public_path__ + "static/share-a077722959938e874f7583c51e0ff0fc.png";